import CreateTransaction from "./CreateTransaction";
import DashboardLayout from "./layout/DashboardLayout";

const CreateTransactionPage = () => {
  return (
    <DashboardLayout>
      <CreateTransaction />
    </DashboardLayout>
  );
};

export default CreateTransactionPage;
